import { createMiddleware } from "@tanstack/react-start";

/**
 * Voegt de inlogsleutel toe aan admin-serverfuncties. De databaseclient wordt
 * pas dynamisch geladen wanneer een adminfunctie draait, zodat openbare
 * pagina's de inlogcode niet in hun bundel krijgen.
 */
export const attachAdminAuth = createMiddleware({ type: "function" }).client(
  async ({ next }) => {
    const { supabase } = await import("@/integrations/supabase/client");
    const { data } = await supabase.auth.getSession();
    const token = data.session?.access_token;
    return next({ headers: token ? { Authorization: `Bearer ${token}` } : {} });
  },
);
